import React from 'react';
import Department from '../components/departments/Department';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ViewDepartments from '../components/departments/ViewDepartments';
import { useParams } from 'react-router-dom';
import NavBar from '../components/NavBar';

const DepartmentsView = () => {

    const deptId = useParams();
    

    return (
        <div>
            <Header />
            <NavBar />
            <Department deptIdToEdit={deptId}/>
            <ViewDepartments limit={6} />
            <Footer />
        </div>
    )
}

export default DepartmentsView
